<template>
  <div class="event" style="margin-right: 10px;">
    <div class="sub-event" :class="{ 'sup-event': i > 0, f: f && i == 0, l: l && i == event.periods.length - 1 }" v-for="(se, i) in event.periods" :key="i">
      <div class="event-cell" v-if="i == 0">
        <!--table v-if="event.animation && event.stream">
          <tr>
            <td>
              <favorite-toggler :active="favorite" type="event" :target="event.id" />
            </td>
            <td>
              <span v-if="event.animation" style="margin-right: 10px; margin-top: 5px; font-size: 16px;" @click="putAnimation()">
                <i-controller style="margin-top: 5px;" :title="null" />
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <statistic-icon @click="openStatistics" method="statistic" :pixel-size="20" style="margin-left: 10px;" />
            </td>
            <td>
              <span v-if="event.stream" style="margin-right: 10px; margin-top: 5px; font-size: 19px;" @click="putStream()">
                <i-television style="margin-top: 2px; margin-left: 1px;" :title="null" />
              </span>
            </td>
          </tr>
        </table>

        <table v-if="!event.animation && !event.stream">
          <tr>
            <td>
              <favorite-toggler :active="favorite" type="event" :target="event.id" />
            </td>
          </tr>
          <tr>
            <td>
              <statistic-icon @click="openStatistics" method="statistic" :pixel-size="20" style="margin-left: 10px;" />
            </td>
            <td style="width: 31px;">
            </td>
          </tr>
        </table>

        <table v-if="event.animation && !event.stream">
          <tr>
            <td>
              <favorite-toggler :active="favorite" type="event" :target="event.id" />
            </td>
            <td rowspan="2">
              <span v-if="event.animation" style="margin-right: 10px; margin-top: 5px; font-size: 16px;" @click="putAnimation()">
                <i-controller style="margin-top: 5px;" :title="null" />
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <statistic-icon @click="openStatistics" method="statistic" :pixel-size="20" style="margin-left: 10px;" />
            </td>
          </tr>
        </table>

        <table v-if="!event.animation && event.stream">
          <tr>
            <td>
              <favorite-toggler :active="favorite" type="event" :target="event.id" />
            </td>
            <td rowspan="2">
              <span v-if="event.stream" style="margin-right: 10px; margin-top: 5px; font-size: 19px;" @click="putStream()">
                <i-television style="margin-top: 2px; margin-left: 1px;" :title="null" />
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <statistic-icon @click="openStatistics" method="statistic" :pixel-size="20" style="margin-left: 10px;" />
            </td>
          </tr>
        </table-->
        <div class="event-info">
          <!--div class="event-kind" v-if="event.kind">{{ event.kind }}</div>
          <div>
            <div class="team">{{ event.home }}</div>
            <div class="turn" v-if="event.results.turn && event.results.turn === 1">
              <sport-icon small :name="sport.alias" />
            </div>
            <div class="point" v-if="event.results.points">{{ event.results.points.home }}</div>
            <div class="score" v-if="event.results.score">{{ event.results.score.home }}</div>
          </div>
          <div v-if="event.away">
            <div class="team">{{ event.away }}</div>
            <div class="turn" v-if="event.results.turn && event.results.turn === 2">
              <sport-icon small :name="sport.alias" />
            </div>
            <div class="point" v-if="event.results.points">{{ event.results.points.away }}</div>
            <div class="score" v-if="event.results.score">{{ event.results.score.away }}</div>
          </div>
          <div class="comment">
            <div class="number blue-color" v-if="event.number">{{ event.number }}</div>
            <div class="time">
              {{ event.results.minute ? event.results.minute : '' }}
              <span class="time-blink" style="margin-left: -2px;" v-if="event.results.minute">'</span>
              {{ event.results.comment }}
            </div>
          </div-->

          <table style="border: none; width: 100%; border-spacing: unset; margin-left: 5px;">
            <tr>
              <td class="time" style="width: 16%;">
                  <div><favorite-toggler style="height: 18px; width: 18px; color: gray;" :active="favorite" type="event" :target="event.id" /></div>
              </td>
              <td @click="followEvent">
                <div class="team">{{ event.home }}</div>
              </td>
              <td style="float: right; display: flex;" @click="followEvent">
                <div class="turn" v-if="event.results.turn && event.results.turn === 1">
                  <sport-icon small :name="sport.alias" />
                </div>
                <div class="point" v-if="event.results.points">{{ event.results.points.home }}</div>
                <div class="score" v-if="event.results.score">{{ event.results.score.home }}</div>
              </td>
            </tr>
            <tr>
              <td class="time" style="width: 16%;" @click="followEvent">
                <span v-if="event.results.minute < 10 && sport.id !== 2" style="margin-left: 5px;">{{ event.results.minute ? event.results.minute : '' }}</span>
                <span v-if="event.results.minute > 9 && sport.id !== 2">{{ event.results.minute ? event.results.minute : '' }}</span>
                <span v-if="sport.id === 2">{{ event.results.minute ? event.results.minute : '' }}</span>
                <span class="time-blink" v-if="event.results.minute">'</span>
              </td>
              <td @click="followEvent">
                <div class="team" v-if="event.away">{{ event.away }}</div>
              </td>
              <td style="float: right; display: flex;" @click="followEvent">
                <div class="turn" v-if="event.results.turn && event.results.turn === 2">
                  <sport-icon small :name="sport.alias" />
                </div>
                <div class="point" v-if="event.results.points">{{ event.results.points.away }}</div>
                <div class="score" v-if="event.results.score">{{ event.results.score.away }}</div>
              </td>
            </tr>
            <tr>
              <td style="width: 16%;" @click="followEvent"></td>
              <td style="font-weight: normal; color: #713592;">{{ event.results.comment }}</td>
              <td style="float: right;">
                <div style="display: flex;">
                  <div @click="openStatistics"><statistic-icon style=" margin-left: 4px;" method="statistic" :pixel-size="15" /></div>
                  <div v-if="event.animation && !event.stream" @click="putAnimation()"><i-controller style="font-size: 16px; margin-left: -4px; color: gray; margin-right: 12px; margin-top: 1px;" :title="null" /></div>
                  <div v-if="event.animation && event.stream" @click="putAnimation()"><i-controller style="font-size: 16px; margin-left: -4px; color: gray; margin-right: 6px; margin-top: 1px;" :title="null" /></div>
                  <div v-if="event.stream" @click="putStream()" style="color: gray;"><i-television style="font-size: 15px; margin-top: 1px; margin-right: 12px;" :title="null"/></div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="event-cell" v-else @click="$router.push(`/live/sport/${sport.id}/event/${event.id}/period/${se.number}`)">{{ se.name }}</div>
      <div class="factors-1 factors" style="margin-right: 10px;">
        <factor-cell
          class="factor-cell"
          :class="{ f: f && j === se.factors[0].length - 1 && i == 0, l: l && j === se.factors[0].length - 1 && i == event.periods.length - 1 }"
          style="height: 27px; margin-top: 17px;"
          v-for="(factor, j) in se.factors[0]"
          :key="j"
          :paused="event.paused"
          :event="event.id"
          :factor="factor" />
      </div>
      <div class="factors-2 factors" style="margin-right: 10px;">
        <factor-cell
          class="factor-cell"
          :class="{ f: f && j === se.factors[1].length - 1 && i == 0, l: l && j === se.factors[1].length - 1 && i == event.periods.length - 1 }"
          style="height: 27px; margin-top: 17px;"
          v-for="(factor, j) in se.factors[1]"
          :key="j"
          :paused="event.paused"
          :event="event.id"
          :factor="factor" />
      </div>
    </div>
  </div>
</template>

<script>
import SportIcon from '@/components/icons/SportIcon'
import FavoriteToggler from '@/components/buttons/FavoriteToggler'
import StatisticIcon from '@/components/icons/StatisticIconGray'
import FactorCell from '@/components/sports/matches/FactorCell'
import IController from 'vue-material-design-icons/GamepadVariant'
import ITelevision from 'vue-material-design-icons/Television'

export default {
  components: { SportIcon, FavoriteToggler, FactorCell, StatisticIcon, IController, ITelevision },
  props: {
    favorite: Boolean,
    event: Object,
    sport: Object,
    f: Boolean,
    l: Boolean
  },
  methods: {
    followEvent (event) {
      if (event.target.classList.value === 'statistic-icon') this.openStatistics()
      if (event.target.classList.value === 'team') this.$router.push(`/live/sport/${this.sport.id}/event/${this.event.id}`)
    },
    openStatistics () {
      // window.open('https://statistic.sportdemo.ru/betspectrumStatistics?id=' + this.event.id + '&lang=' + this.$i18n.locale, 'statistics', 'width=1000,height=700,menubar=no,toolbar=no,location=no')
      window.open('https://statistic.sportdemo.ru/statistics?lang=' + this.$i18n.locale, 'statistics', 'width=1000,height=700,menubar=no,toolbar=no,location=no')
    },
    putAnimation () {
      // window.open('http://animation.demobetstil.ru/animation/stream/id/' + this.event.id + '/lang/ru', 'animation', 'width=450,height=350,menubar=no,toolbar=no,location=no,scrollbar=no')
      window.open(this.event.animation, 'animation', 'width=450,height=350,menubar=no,toolbar=no,location=no,scrollbar=no')
    },
    putStream () {
      console.log(this.event.stream.substring(1, this.event.stream.length - 1))
      window.open(this.event.stream.substring(1, this.event.stream.length - 1), '_blank')
    }
  }
}
</script>

<style scoped>
.event.closed .sup-event { display: none; }
.sub-event { display: flex; }
.event-cell { align-items: center; background: rgba(255, 255, 255, .1); cursor: pointer; display: flex; flex: 0 0 32%; max-width: 32%; padding: 5px 3px 5px 0; -webkit-transition: background .3s; -moz-transition: background .3s; -o-transition: background .3s; transition: background .3s; }
.event-cell:hover { background: rgba(255, 255, 255, .15); }
.f .event-cell { border-top-left-radius: 5px; }
.l .event-cell { border-bottom-left-radius: 5px; }

.favorite-toggler { flex-shrink: 0; /* margin: 0 5px; */ }
.event-info { flex: 1 1; min-width: 0; }
.event-info > div { display: flex; }
.event-kind { color: #ffa726; height: 17px; }
.team { flex: 1; height: 17px; margin-right: 10px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 120px;}
.turn { margin-top: -1px; }
.point { color: #ffa726; text-align: center; width: 20px; }
.score { color: #ffd54f; text-align: center; width: 24px; }
.comment { display: flex; height: 17px; padding-right: 5px; width: 100%; }
.number { margin-right: 8px; }
.time { color: #713592; flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.sub-event { margin-top: 5px; }
.sub-event .event-cell { display: block; padding: 5px 10px; }
.factors { display: none; flex: 1 1; }
.f.factor-cell { border-top-right-radius: 5px; }
.l.factor-cell { border-bottom-right-radius: 5px; }
.gamepad-variant-icon { font-size: 21px; }
</style>



// WEBPACK FOOTER //
// src/components/live/overview/Event.vue